import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { IMAGE_UPLOADER_FAILED, IMAGE_UPLOADER_SUCCESS, S3_UPLOADER_FAILED, S3_UPLOADER_SUCCESS } from "../Actions/ImageUploader";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* ImageUploaderSaga(action: any): unknown {
    try {
        const response = yield call(axios.post, 'generateQR', action.payload);
        // console.log(response);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: IMAGE_UPLOADER_SUCCESS, payload: data?.resqr });
            // yield put({
            //     type: TOAST_SHOW,
            //     payload: { message: data.message, severity: 'Success', show: true },
            // });
        }

    } catch (e: any) {
        yield put({ type: IMAGE_UPLOADER_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* S3UploaderSaga(action: any): unknown {
    try {
        const response = yield call(axios.post, 'uploadS3', action.payload);
        const { data, status } = response
        // console.log(data);

        if (status === 200) {
            yield put({ type: S3_UPLOADER_SUCCESS, payload: data });
            // yield put({
            //     type: TOAST_SHOW,
            //     payload: { message: '', severity: 'Success', show: true },
            // });
        }

    } catch (e: any) {
        yield put({ type: S3_UPLOADER_FAILED, payload: '' });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}